const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
const phoneLayout = window.matchMedia('(max-width: 768px)');
const motionAllowed = () => !reducedMotion.matches;
const heroDecor = document.querySelector(".world-decor");
const tiltCards = [...document.querySelectorAll("[data-tilt]")];

function resetPointerEffects() {
  tiltCards.forEach((card) => {
    card.style.removeProperty("--tilt-x");
    card.style.removeProperty("--tilt-y");
  });
  heroDecor?.style.removeProperty("--parallax-x");
  heroDecor?.style.removeProperty("--parallax-y");
}

function updateMotionPreference() {
  const paused = !motionAllowed();
  document.body.dataset.motion = paused ? "paused" : "active";
  document.documentElement.style.scrollBehavior = paused ? "auto" : "";
  if (paused) {
    resetPointerEffects();
    document.querySelectorAll(".play-sparkle").forEach((sparkle) => sparkle.remove());
  }
}
reducedMotion.addEventListener("change", updateMotionPreference);
finePointer.addEventListener("change", resetPointerEffects);
updateMotionPreference();

// Event-driven transforms only: no persistent requestAnimationFrame loop.
tiltCards.forEach((card) => {
  let bounds;
  card.addEventListener("pointerenter", (event) => {
    if (event.pointerType === "mouse" && finePointer.matches && motionAllowed()) bounds = card.getBoundingClientRect();
  });
  card.addEventListener("pointermove", (event) => {
    if (!bounds || event.pointerType !== "mouse" || !finePointer.matches || !motionAllowed()) return;
    const x = Math.max(-.5, Math.min(.5, (event.clientX - bounds.left) / bounds.width - .5));
    const y = Math.max(-.5, Math.min(.5, (event.clientY - bounds.top) / bounds.height - .5));
    card.style.setProperty("--tilt-x", `${-y * 10}deg`);
    card.style.setProperty("--tilt-y", `${x * 10}deg`);
  });
  card.addEventListener("pointerleave", () => {
    bounds = null;
    card.style.removeProperty("--tilt-x");
    card.style.removeProperty("--tilt-y");
  });
});

const hero = document.querySelector(".world-hero");
if (hero && heroDecor) hero.addEventListener("pointermove", (event) => {
  if (event.pointerType !== "mouse" || !finePointer.matches || !motionAllowed()) return;
  heroDecor.style.setProperty("--parallax-x", `${(event.clientX / window.innerWidth - .5) * 12}px`);
  heroDecor.style.setProperty("--parallax-y", `${(event.clientY / window.innerHeight - .5) * 10}px`);
});
if (hero && heroDecor) hero.addEventListener("pointerleave", () => {
  heroDecor?.style.removeProperty("--parallax-x");
  heroDecor?.style.removeProperty("--parallax-y");
});

// Short, bounded bursts are removed even if a motion preference changes mid-play.
function sparkleBurst(container, x, y, count = 8) {
  if (!motionAllowed()) return;
  if (phoneLayout.matches) count = Math.min(count, 5);
  const colors = ["#ffdc70", "#ff8fc2", "#a5e9da", "#c6b4ff"];
  for (let index = 0; index < count; index += 1) {
    if (document.querySelectorAll(".play-sparkle").length >= (phoneLayout.matches ? 20 : 48)) break;
    const sparkle = document.createElement("span");
    sparkle.className = "play-sparkle";
    sparkle.setAttribute("aria-hidden", "true");
    sparkle.style.left = `${x}px`;
    sparkle.style.top = `${y}px`;
    const angle = (index / count) * Math.PI * 2;
    const distance = 24 + Math.random() * 40;
    sparkle.style.setProperty("--spark-x", `${Math.cos(angle) * distance}px`);
    sparkle.style.setProperty("--spark-y", `${Math.sin(angle) * distance}px`);
    sparkle.style.setProperty("--spark-color", colors[index % colors.length]);
    container.append(sparkle);
    setTimeout(() => sparkle.remove(), 700);
  }
}

const destinations = {
  space: { story: "blasting off to", name: "SPACE", coordinate: "NEXT STOP: THE STARS", friends: "🧑‍🚀 🧑‍🚀", crew: "🧑‍🚀 👩‍🚀 🧑‍🚀" },
  jungle: { story: "exploring the", name: "JUNGLE", coordinate: "FOLLOW THE GIGGLES", friends: "🧑‍🌾 🧑‍🌾", crew: "🧑‍🌾 👩‍🌾 🧑‍🌾" },
  base: { story: "sneaking into our", name: "SECRET BASE", coordinate: "TOP SECRET. EXTRA FUN.", friends: "🥷 🥷", crew: "🥷 🦸 🥷" },
};
const missions = { treasure: { name: "TREASURE", icon: "💎" }, aliens: { name: "ALIENS", icon: "👽" }, portal: { name: "A HIDDEN PORTAL", icon: "🌀" } };
const companions = { friend: "OUR BEST FRIEND", crew: "THE WHOLE CREW", teddy: "A VERY BRAVE TEDDY" };
const choices = document.querySelector("[data-adventure-choices]");
if (choices) {
const adventureWindow = document.querySelector("[data-adventure-window]");
const story = document.querySelector("[data-adventure-story]");
const storyTicket = story.closest('.story-ticket');
const storyPosition = document.createComment('Desktop story position');
storyTicket.before(storyPosition);
function positionStory() {
  if (phoneLayout.matches) choices.before(storyTicket);
  else storyPosition.after(storyTicket);
}
phoneLayout.addEventListener('change', positionStory);
positionStory();
let storyAnimationTimer;

function updateAdventure(animate = true) {
  const values = new FormData(choices);
  const location = values.get("location");
  const destination = destinations[location];
  const mission = missions[values.get("mission")];
  const companion = values.get("companion");
  adventureWindow.dataset.location = location;
  adventureWindow.querySelectorAll(".scene-landscape").forEach(scene => { scene.hidden = !scene.classList.contains(`scene-${location}`); });
  adventureWindow.querySelector("[data-scene-mission]").textContent = mission.icon;
  adventureWindow.querySelector("[data-scene-companion]").textContent = companion === "teddy" ? "🧸" : companion === "crew" ? destination.crew : destination.friends;
  adventureWindow.querySelector("[data-scene-coordinate]").textContent = destination.coordinate;
  // All story fragments come from the local choices above, never customer input.
  story.innerHTML = `Today we’re ${destination.story} <strong>${destination.name}</strong> to find <strong>${mission.name}</strong> with <strong>${companions[companion]}</strong>.`;
  adventureWindow.querySelector("[data-adventure-scene]").setAttribute("aria-label", story.textContent);
  const ticket = story.closest(".story-ticket");
  clearTimeout(storyAnimationTimer);
  ticket.classList.remove("is-remixing");
  if (animate && motionAllowed()) {
    void ticket.offsetWidth;
    ticket.classList.add("is-remixing");
    storyAnimationTimer = setTimeout(() => ticket.classList.remove("is-remixing"), 450);
  }
}
choices.addEventListener("submit", event => event.preventDefault());
choices.addEventListener("change", () => updateAdventure());
document.querySelector("[data-surprise]").addEventListener("click", () => {
  const previous = [...new FormData(choices)].toString();
  do {
    for (const field of choices.querySelectorAll("fieldset")) {
      const options = field.querySelectorAll("input");
      options[Math.floor(Math.random() * options.length)].checked = true;
    }
  } while ([...new FormData(choices)].toString() === previous);
  updateAdventure();
  sparkleBurst(adventureWindow, adventureWindow.clientWidth / 2, adventureWindow.clientHeight * .7, 18);
});
updateAdventure(false);
}

function playTargetBounds(field, button) {
  // Leave room for the existing bob/drift animations, including star rotation.
  const padding = button.classList.contains('star-target') ? 24 : 12;
  const width = button.offsetWidth;
  const height = button.offsetHeight;
  const roomX = Math.max(0, field.clientWidth - width);
  const roomY = Math.max(0, field.clientHeight - height);
  const minX = Math.min(padding, roomX / 2);
  const minY = Math.min(padding, roomY / 2);
  return { width, height, minX, minY, maxX: roomX - minX, maxY: roomY - minY };
}

function randomPlayPosition(field, button) {
  const bounds = playTargetBounds(field, button);
  const oldX = button.offsetLeft;
  const oldY = button.offsetTop;
  const others = [...field.querySelectorAll('.play-target:not([hidden])')]
    .filter(other => other !== button)
    .map(other => ({ x: other.offsetLeft + other.offsetWidth / 2, y: other.offsetTop + other.offsetHeight / 2, radius: Math.max(other.offsetWidth, other.offsetHeight) / 2 }));
  const radius = Math.max(bounds.width, bounds.height) / 2;
  const minimumMove = Math.min(radius * 2, Math.hypot(bounds.maxX - bounds.minX, bounds.maxY - bounds.minY) * .45);
  let best;
  let bestOverlap = Infinity;
  // Eight random candidates, then four safe corners as a bounded fallback.
  // At least one corner is far enough away even if every random pick is nearby.
  for (let attempt = 0; attempt < 12; attempt += 1) {
    const x = attempt < 8 ? bounds.minX + Math.random() * (bounds.maxX - bounds.minX) : (attempt % 2 ? bounds.maxX : bounds.minX);
    const y = attempt < 8 ? bounds.minY + Math.random() * (bounds.maxY - bounds.minY) : (attempt >= 10 ? bounds.maxY : bounds.minY);
    if (Math.hypot(x - oldX, y - oldY) < minimumMove) continue;
    const overlap = others.reduce((total, other) => {
      const distance = Math.hypot(x + bounds.width / 2 - other.x, y + bounds.height / 2 - other.y);
      return total + Math.max(0, radius + other.radius + 12 - distance) ** 2;
    }, 0);
    if (overlap < bestOverlap) { best = { x, y }; bestOverlap = overlap; }
    if (overlap === 0) break;
  }
  return best || { x: bounds.minX, y: bounds.minY };
}

function movePlayTarget(field, button) {
  if (button.hidden) return;
  const { x, y } = randomPlayPosition(field, button);
  button.style.left = `${x}px`;
  button.style.top = `${y}px`;
}

// Keep each target's native button, focus, feedback, and initial arrangement.
function initPlayTargets(kind, count) {
  const field = document.querySelector(`[data-${kind}-field]`);
  const feedback = document.querySelector(`[data-${kind}-feedback]`);
  if (!field || !feedback) return;
  let taps = 0;
  for (let index = 0; index < count; index += 1) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = `play-target ${kind}-target`;
    button.setAttribute("aria-label", `${kind === "bubble" ? "Pop bubble" : "Catch star"} ${index + 1}`);
    const syncTarget = () => { button.hidden = phoneLayout.matches && index >= (kind === 'bubble' ? 4 : 2); };
    phoneLayout.addEventListener('change', syncTarget);
    syncTarget();
    button.style.setProperty("--delay", `${-index * 1.2}s`);
    if (kind === "star") button.innerHTML = '<span aria-hidden="true">✦</span>';
    function initialPosition() {
      const column = index % 3;
      const row = Math.floor(index / 3);
      const x = column * 30 + 2 + Math.random() * 5;
      const y = count > 3 ? row * 44 + 9 + Math.random() * 9 : 13 + column % 2 * 32 + Math.random() * 10;
      button.style.left = `calc(${x}% + 4px)`;
      button.style.top = `${y}%`;
    }
    initialPosition();
    function activate() {
      if (button.classList.contains("is-respawning")) return;
      taps += 1;
      feedback.textContent = kind === "bubble" ? `${taps} ${taps === 1 ? "bubble" : "bubbles"} popped!` : taps % 2 ? "You caught a star! ✨" : "You caught another star! ✨";
      const bounds = button.getBoundingClientRect();
      const parentBounds = field.getBoundingClientRect();
      sparkleBurst(field, bounds.x - parentBounds.x + bounds.width / 2, bounds.y - parentBounds.y + bounds.height / 2);
      if (!motionAllowed()) { movePlayTarget(field, button); return; }
      button.classList.add("is-respawning");
      setTimeout(() => { movePlayTarget(field, button); button.classList.remove("is-respawning"); }, 180);
    }
    let pointerStart;
    button.addEventListener('pointerdown', event => {
      if (event.isPrimary && event.button === 0) pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
    });
    button.addEventListener('pointercancel', () => { pointerStart = null; });
    button.addEventListener('pointerup', event => {
      const start = pointerStart;
      pointerStart = null;
      if (start?.id === event.pointerId && Math.hypot(event.clientX - start.x, event.clientY - start.y) <= 10) activate();
    });
    button.addEventListener('click', event => {
      // Native keyboard / assistive activation; pointer activation was handled above.
      if (event.detail === 0) activate();
    });
    field.append(button);
  }
  const clampTargets = () => {
    field.querySelectorAll('.play-target:not([hidden])').forEach(button => {
      const { minX, minY, maxX, maxY } = playTargetBounds(field, button);
      const x = button.offsetLeft;
      const y = button.offsetTop;
      // Only adjust targets that no longer fit; ordinary resizes don't reshuffle.
      if (x < minX || x > maxX) button.style.left = `${Math.max(minX, Math.min(maxX, x))}px`;
      if (y < minY || y > maxY) button.style.top = `${Math.max(minY, Math.min(maxY, y))}px`;
    });
  };
  new ResizeObserver(clampTargets).observe(field);
  phoneLayout.addEventListener('change', clampTargets);
}
initPlayTargets("bubble", 6);
initPlayTargets("star", 3);

const launchButton = document.querySelector("[data-launch]");
if (launchButton) {
const sillyObject = document.querySelector("[data-silly-object]");
const launchCount = document.querySelector("[data-launch-count]");
const launchLabel = document.querySelector("[data-launch-label]");
const launchFeedback = document.querySelector("[data-launch-feedback]");
const whoosh = document.querySelector("[data-whoosh]");
const sillyObjects = [{ icon: "🚀", name: "rocket" }, { icon: "⭐", name: "star" }, { icon: "🌈", name: "rainbow" }, { icon: "🧸", name: "teddy" }, { icon: "🎈", name: "balloon" }];
let launching = false;
let launchTimer;
let launchedObject = sillyObjects[0];
function finishLaunch() {
  clearTimeout(launchTimer);
  launching = false;
  launchButton.setAttribute("aria-disabled", "false");
  sillyObject.classList.remove("is-launching");
  launchCount.textContent = "3 · 2 · 1";
  launchLabel.textContent = "GO! ↑";
}
function fly() {
  whoosh.textContent = "WHOOSH!";
  launchFeedback.textContent = `One ${launchedObject.name}, off on a very silly adventure!`;
  launchCount.textContent = "WHEEE!";
  launchLabel.textContent = "GO!";
  if (motionAllowed()) {
    sillyObject.classList.add("is-launching");
    launchTimer = setTimeout(finishLaunch, 1150);
  } else finishLaunch();
}
launchButton.addEventListener("click", () => {
  if (launching) return;
  launching = true;
  launchButton.setAttribute("aria-disabled", "true");
  launchedObject = sillyObjects[Math.floor(Math.random() * sillyObjects.length)];
  sillyObject.textContent = launchedObject.icon;
  whoosh.textContent = "";
  launchFeedback.textContent = "Ready for a little silliness? Here we go!";
  if (!motionAllowed()) { fly(); return; }
  let countdown = 3;
  const tick = () => {
    if (!motionAllowed() || countdown === 0) { fly(); return; }
    launchCount.textContent = "READY?";
    launchLabel.textContent = String(countdown--);
    launchTimer = setTimeout(tick, 550);
  };
  tick();
});
function syncLaunchMotion() {
  if (launching && !motionAllowed()) { clearTimeout(launchTimer); fly(); }
}
reducedMotion.addEventListener("change", syncLaunchMotion);
}

// Native scrolling keeps vertical gestures predictable; dots also support keyboards.
const track = document.querySelector('[data-orbit-products]');
if (track) {
track.id = 'toy-showcase';
const pagination = document.createElement('div');
pagination.className = 'showcase-pagination';
pagination.setAttribute('role', 'group');
pagination.setAttribute('aria-label', 'Choose a toy to explore');
const cards = [...track.children];
cards.forEach((card, index) => {
  const dot = document.createElement('button');
  dot.type = 'button';
  dot.setAttribute('aria-label', `Show ${card.querySelector('strong')?.textContent?.trim() || `toy ${index + 1}`}`);
  dot.setAttribute('aria-controls', track.id);
  dot.addEventListener('click', () => track.scrollTo({ left: card.offsetLeft - cards[0].offsetLeft, behavior: motionAllowed() ? 'smooth' : 'instant' }));
  pagination.append(dot);
});
track.after(pagination);
let scrollFrame;
function updatePagination() {
  cancelAnimationFrame(scrollFrame);
  scrollFrame = requestAnimationFrame(() => {
    let closest = 0;
    cards.forEach((card, index) => {
      if (Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) < Math.abs(cards[closest].offsetLeft - cards[0].offsetLeft - track.scrollLeft)) closest = index;
    });
    [...pagination.children].forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === closest)));
  });
}
track.addEventListener('scroll', updatePagination, { passive: true });
updatePagination();
let swipeStart;
let dragged = false;
track.addEventListener('pointerdown', event => { swipeStart = { x: event.clientX, y: event.clientY }; dragged = false; });
track.addEventListener('pointermove', event => {
  if (swipeStart && Math.hypot(event.clientX - swipeStart.x, event.clientY - swipeStart.y) > 10) dragged = true;
}, { passive: true });
track.addEventListener('pointercancel', () => { dragged = true; swipeStart = null; });
track.addEventListener('pointerup', () => { swipeStart = null; });
track.addEventListener('click', event => { if (dragged) { event.preventDefault(); dragged = false; } }, { capture: true });

}
const animationObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => entry.target.classList.toggle('is-offscreen', !entry.isIntersecting));
}, { rootMargin: '100px' });
document.querySelectorAll('.world-hero, .play-marquee, .adventure-window, .play-zone, .why-section, .final-section').forEach(section => animationObserver.observe(section));
document.addEventListener('visibilitychange', () => document.body.classList.toggle('is-background', document.hidden));
